module.exports = __webpack_public_path__ + "static/img/TH_Wildau_Logo_white.4ac23ea0.png";